import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const modify_email = (
  id,
  mailUser,
  mailPassword,
  mailKey,
  smtpServeraddress,
  port,
  status,
  ip,
  updateTime
) => {
  return api.post(`${ApiEndpointConstants.MODIFYEMAIL}`, {
    id,
    mailUser,
    mailPassword,
    mailKey,
    smtpServeraddress,
    port,
    status,
    ip: ip || "",
    updateTime,
  });
};
